import { useEffect } from "react";

import innerStyles from "./innerInputForForm.module.css";

function InputForForm({
  register,
  inputProps,
  dataForm,
  externalStyles,
  setValue,
  setError,
  mode,
  errors = {},
  clearErrors,
  getValues,
}) {
  useEffect(() => {
    if (inputProps.type === "date" && dataForm?.[inputProps.key]?.includes(".")) {
      const match = dataForm?.[inputProps.key].match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (match === null) {
        return "Неверный формат даты";
      }
      const day = match[1];
      const month = match[2];
      const year = match[3];
      dataForm[inputProps.key] = year + "-" + month + "-" + day;
    }
    setValue(inputProps.key, dataForm?.[inputProps.key]);
  }, [dataForm]);

  return (
    <div className={`${externalStyles?.container} ${innerStyles["container"]}`}>
      <label className={`${externalStyles?.label} ${innerStyles["label"]}`}>
        {inputProps.label}
        {inputProps.required && mode !== "view" && <span className={innerStyles["red-dot"]}>*</span>}
      </label>
      {inputProps.textarea ? (
        <textarea
          id={inputProps.key}
          type={inputProps.type}
          rows={inputProps.rows}
          className={`${innerStyles["form-input"]} ${externalStyles?.input} ${
            errors[inputProps.key] ? innerStyles["error-border"] : ""
          }`}
          placeholder={inputProps.placeholder || "Введите"}
          disabled={inputProps.disabled || mode === "view"}
          {...register(inputProps.key, {
            required: inputProps.required && `Заполните поле`,
          })}
        />
      ) : (
        <input
          id={inputProps.key}
          type={inputProps.type}
          className={`${innerStyles["form-input"]} ${externalStyles?.input} ${
            errors[inputProps.key] && innerStyles["error-border"]
          }`}
          placeholder={inputProps.placeholder || "Введите"}
          disabled={inputProps.disabled || mode === "view"}
          {...register(inputProps.key, {
            onChange: (e) => {
              e.target.value = inputProps.upperCase
                ? e.target.value.toUpperCase()
                : inputProps.dotAutoCorrect
                ? e.target.value.replace(",", ".")
                : e.target.value;
            },
            required: inputProps.required && `Заполните поле`,
            maxLength: {
              value: inputProps.maxLength,
              message: `Максимум ${inputProps.maxLength} символов`,
            },
            pattern: {
              value: inputProps.pattern && inputProps.pattern.value,
              message: inputProps.pattern && inputProps.pattern.message,
            },
            validate: {
              customValidation: (value) => {
                if (inputProps.hasOwnProperty("customValidation")) {
                  return inputProps.customValidation(
                    value,
                    getValues && getValues(),
                    setError && setError,
                    clearErrors && clearErrors,
                  );
                }
              },
            },
            ...(inputProps.customValidation &&
              !inputProps.validateOnSaveOnly && {
                onChange: (e) => {
                  setValue(inputProps.key, e.target.value, {
                    shouldValidate: true,
                  });
                },
              }),
          })}
        />
      )}

      {errors[inputProps.key] && (
        <div className={innerStyles["error-text"]}>{errors[inputProps.key].message}</div>
      )}
    </div>
  );
}

export default InputForForm;
